import React from "react";
import withStyles from "react-jss";
import classNames from "classnames";
import { isMainSiteCode } from "Utils/siteConfig";

const styles = (theme) => {
	return {
		root: {
			width: "230px",
			flexShrink: 0,
			display: "flex",
			flexDirection: "column",
			listStyle: "none",
			margin: 0,
			padding: 0,
		},
		root101: {},
		[`@media (min-width: ${theme.media.lg})`]: {
			root101: {
				"&:nth-child(2)": {
					width: "220px",
				},
				"&:nth-child(3)": {
					width: "270px",
				},
			},
		},
		[`@media (min-width: ${theme.media.md}) and (max-width: ${theme.media.lg})`]: {
			root: {
				width: "190px",
				"&:nth-child(3)": {
					width: "230px",
				},
				"&:nth-child(4)": {
					width: "230px",
				},
			},
			root101: {
				"&:nth-child(3)": {
					width: "240px",
				},
			},
		},
		[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
			root: {
				width: "180px",
				"&:nth-child(3)": {
					width: "240px",
					paddingLeft: "25px",
				},
				"&:nth-child(4)": {
					width: "230px",
					paddingLeft: "25px",
				},
			},
		},
		[`@media (max-width: ${theme.media.sm})`]: {
			root: {
				width: "100%",
				flexDirection: "column",
				flexWrap: "wrap",
				marginBottom: "40px",
				justifyContent: "center",
				"&:last-child": {
					marginBottom: 0,
				},
			},
		},
	};
};

class FooterMenuCol extends React.Component {
	render() {
		let classes = this.props.classes;
		return (
			<ul
				className={classNames(classes.root, {
					[classes.root101]: isMainSiteCode(this.props.siteCode),
				})}
			>
				{this.props.children}
			</ul>
		);
	}
}

export default withStyles(styles)(FooterMenuCol);
